import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { IS_TENANT_CONTEXT_TAB_ENABLED } from '@/config/env';
import { useMessages } from '@/hooks/messages';

import { AiAdvisoryLayoutMessages } from './messages';

export type AiAdvisoryAdminTab = 'settings' | 'tenant-context';

interface AiAdvisoryAdminLayoutProps {
  activeTab: AiAdvisoryAdminTab;
  children: ReactNode;
}

export const AiAdvisoryAdminLayout = ({ activeTab, children }: AiAdvisoryAdminLayoutProps) => {
  const messages = useMessages(AiAdvisoryLayoutMessages);

  const tabClass = (tab: AiAdvisoryAdminTab) =>
    activeTab === tab ? 'font-bold !outline-hidden' : 'hover:bg-c4 hover:text-white';

  const activeStyle = { backgroundColor: 'var(--color-dark-grey-4)', color: 'var(--primary)' };

  return (
    <div className='flex w-full flex-col gap-4'>
      <nav className='flex flex-wrap gap-2 pb-2'>
        <Link
          to='/administration/ai-wizard/'
          className={`rounded-lg px-3.5 py-2 text-sm ${tabClass('settings')}`}
          style={activeTab === 'settings' ? activeStyle : undefined}
        >
          {messages.tabSettings()}
        </Link>
        {IS_TENANT_CONTEXT_TAB_ENABLED && (
          <Link
            to='/administration/ai-wizard/tenant-context/'
            className={`rounded-lg px-3.5 py-2 text-sm ${tabClass('tenant-context')}`}
            style={activeTab === 'tenant-context' ? activeStyle : undefined}
          >
            {messages.tabTenantContext()}
          </Link>
        )}
      </nav>
      {children}
    </div>
  );
};
